import dayjs from 'dayjs'
import { getMarket } from '@/utils/utils'

export default (Vue) => {
  Vue.prototype.$funs = {
    getMarket,
    timeFormatByFromNow(date) {
      // 判断是否为同一天
      const isSameDay = dayjs().isSame(date, 'day')
      let result = dayjs()
      // 一小时内，且在同一天，显示xx分钟前
      if (isSameDay && dayjs().isBefore(dayjs(date).add(1, 'h'))) {
        result = (dayjs().diff(dayjs(date)) / (1000 * 60)).toFixed(0) + '分钟前'
      }
      // 超出一小时，但在同一天，显示xx小时前
      else if (isSameDay) {
        // result = (dayjs().diff(dayjs(date)) / (1000 * 60 * 60)).toFixed(0) + '小时前'
        result = dayjs(date).format('HH:mm')
      }
      // 超出一天，但在同一年，显示 MM-DD HH:mm
      else if (dayjs().isSame(date, 'year')) {
        result = dayjs(date).format('MM-DD HH:mm')
      }
      // 跨年，显示 YYYY-MM-DD HH:mm
      else {
        result = dayjs(date).format('YYYY-MM-DD HH:mm')
      }
      return result
    }
  }
}
